module.exports = __webpack_public_path__ + "img/avatarAdmin.996c9cf2.png";